import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PhoneMissedIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78 0.29 16.67C0.11 16.85 0 17.1 0 17.38S0.11 17.91 0.29 18.09L2.77 20.57C2.95 20.75 3.2 20.86 3.48 20.86C3.75 20.86 4 20.75 4.18 20.58C4.97 19.84 5.87 19.22 6.84 18.73C7.17 18.57 7.4 18.23 7.4 17.83L7.4 14.73C8.85 14.25 10.4 14 12 14S15.15 14.25 16.6 14.72L16.6 17.82C16.6 18.21 16.83 18.56 17.16 18.72C18.14 19.21 19.03 19.84 19.83 20.57C20.01 20.75 20.26 20.85 20.53 20.85C20.81 20.85 21.06 20.74 21.24 20.56L23.72 18.08C23.9 17.9 24.01 17.65 24.01 17.37S23.89 16.85 23.71 16.67ZM5.4 17.23C4.74 17.6 4.11 18.03 3.53 18.5L2.46 17.43C3.37 16.68 4.36 16.04 5.41 15.53L5.41 17.23ZM20.48 18.49C19.88 18.01 19.26 17.59 18.6 17.22L18.6 15.52C19.65 16.03 20.63 16.67 21.55 17.42L20.48 18.49ZM7 6.43L11.94 11.37L19.01 4.3L17.6 2.88L11.94 8.54L8.4 5L11 5L11 3L5 3L5 9L7 9Z"
      fill="currentColor"
    />
  </svg>
);

PhoneMissedIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PhoneMissedIcon);
